module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "channel-list-wrapper"
  }, _vm._l((_vm.channels), function(channel) {
    return _c('div', {
      key: channel.id,
      staticStyle: {
        "margin": "0 10px 5px 0"
      }
    }, [_c('el-card', {
      attrs: {
        "shadow": "hover"
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": channel.channel_type_title
      }
    }, [_c('social-icon', {
      staticClass: "social-icon",
      attrs: {
        "type": channel.channel_type_title
      }
    })], 1), _vm._v(" "), _c('strong', {
      staticClass: "channel-handle"
    }, [_vm._v(_vm._s(channel.handle))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": ((_vm.active ? 'Deactivate' : 'Activate') + " " + (channel.handle))
      }
    }, [_c('span', {
      staticClass: "fa fa-fw pull-right channel-action",
      class: _vm.logoClass,
      style: ({
        color: _vm.logoColor
      }),
      on: {
        "click": function($event) {
          return _vm.toggleChannelActive(channel)
        }
      }
    })])], 1)], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-081d153a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/ChannelList.vue
// module id = 3124
// module chunks = 3